// settings.js

// Define constants for the port and default port
const DEFAULT_PORT = 9020;
// Dev-only: when the app is served over the tailnet via `tailscale serve`,
// API calls must go to the serve port that proxies to the Flask backend
// (:8447), not the raw backend port (:9020) which the host firewall keeps
// loopback-only. Production (no port in the URL) stays same-origin.
const TAILNET_API_PORT = 8447;

// Function to get the current domain
function getCurrentDomain() {
  return `${window.location.protocol}//${window.location.hostname}`;
}

function isTailnetServed() {
  return window.location.hostname.endsWith('.ts.net') && Boolean(window.location.port);
}

// Function to get the full URL, potentially with a new port
function getUrl(newPort = DEFAULT_PORT) {
  const currentDomain = getCurrentDomain();
  if (isTailnetServed()) {
    return `${currentDomain}:${TAILNET_API_PORT}`;
  }
  return window.location.port ? `${currentDomain}:${newPort}` : currentDomain;
}

// Export the settings
const settings = {
  getCurrentDomain,
  getUrl,
};

export default settings;
